import OlSelect from 'ol/interaction/Select';
import { useCallback } from 'react';
import { useOpenLayers } from '../react-ol';
/**
 * Resets all Select interactions on the map
 *
 * If an interactionId is given it will reset that interaction only
 *
 * Should be used within the map context
 *
 */

var useResetSelection = interactionId => {
  var {
    map
  } = useOpenLayers();

  var resetSelection = interaction => {
    interaction.getFeatures().clear(); // emit change event so we can capture this in useGeometry to reset selectedFeatures[]

    interaction.changed();
  };

  return useCallback(() => {
    if (!map) return;
    var interactions = map.getInteractions().getArray();
    var selectInteractions = interactions === null || interactions === void 0 ? void 0 : interactions.filter(act => act instanceof OlSelect);
    selectInteractions.forEach(interaction => {
      // reset given id's interaction only
      if (interactionId && interaction.get('interactionId') === interactionId) {
        resetSelection(interaction);
      } // reset all interactions


      if (!interactionId) {
        resetSelection(interaction);
      }
    });
  }, [interactionId, map]);
};

export default useResetSelection;